/* Component Dependencies */
var $ = require('jquery');
var _ = require('lodash');
var creditCardFormTemplateUnAuth = require('templates/creditCard-guestInfo.hbs');
var creditCardConfirmDetailTemplate = require('templates/creditCard-reviewDetails.hbs');
var creditCardBookedTemplate = require('templates/creditCard-booked.hbs');
var creditCardQuickGroupsTemplate = require('templates/creditCard-quickGroups.hbs');
var creditCardGuestInfoNewTemplate = require('templates/creditCard-guestInfo-new.hbs');
var AriesComponent = require('libs/aries-component');
var PubSub = require('libs/pub-sub');
var Popup = require('libs/popup');
var Constants = require('libs/constants');
var autoFormat = require('reservation_libs/auto-format');

PubSub.register(AriesComponent.extend({
  type: 'creditCard',

  template: {
    // There can be multiple templates for a component.
    // Replace key as component name if template name is
    // not same as component name
    'creditCard-guestInfo': creditCardFormTemplateUnAuth,
    'creditCard-reviewDetails': creditCardConfirmDetailTemplate,
    'creditCard-quickGroups': creditCardQuickGroupsTemplate,
    'creditCard-guestInfo-new': creditCardGuestInfoNewTemplate,
    'creditCard-booked': creditCardBookedTemplate
  },

  events: {
    'click .js-show-more': 'showAllCards',
    'click .js-close': 'collapseCards',
    'click #enterCreditCard': 'enableAlternateCard',
    'click #saveCreditCardField': 'setInputString',
    'click .guest-credit-card-list label': 'setGreyBgColor',
    'click .js-credit-card-popover': 'getCcPopUp',
    'click #isPreferredSelected': 'togglePreference'
  },

  setGreyBgColor: function _setGreyBgColor() {
    var _self = this;
    if($('#credit-card-number').hasClass('t-form-error-frame')) {
	$('#credit-card-number').removeClass('t-form-error-frame');
    }
  },

  /**
  * Enable the creditcardNumber filed when alternate card raio is selected
  * @method enableAlternateCard
  * @return {[void]}
  */
  enableAlternateCard: function _enableAlternateCard() {
    var _self = this;
    if($('.guest-credit-card-add input:checked').val() == "A" || $('.guest-credit-card-add input:checked').val() == "E") {
	$('#credit-card-number').attr('readonly', false);
    }
  },

  /**
  * Set inputString as hidden input: number and addSelectedCard based on creditCard
  * @method setInputString
  * @return {[void]}
  */
  setInputString: function setInputString(){
   var _self = this;
      var inputString = '';
      var selectedCreditCardRadio = $('.guest-credit-card-list input:checked');
      var isPreferredSelected = $('#isPreferredSelected').prop("checked");
      var showSection = $('.js-credit-card-tile').data('creditcardshowsection');
          if (($('#creditCardSavebleMsgDiv input:checked').val()) || ($('#makePrimaryCard input:checked').val())){
  	    var formattedCCardNumber = $('#credit-card-number').val();
  	    var creditCardNumber = formattedCCardNumber.replace(/\s/g, '');
  	    var paymentID = '';
  	    var addSelectedCard = false;
  	    if(selectedCreditCardRadio.val()){
  		addSelectedCard = false;
  		paymentID = selectedCreditCardRadio.data('payment-id');
  	    } else if($('.guest-credit-card-add input:checked') || (showSection == false)) {
  		addSelectedCard = true;
  	    }
  	    inputString = "number=" + creditCardNumber + "&addCardSelected=" + addSelectedCard;
  	    if(paymentID){
  	    	inputString= inputString + "&paymentMethodId=" + paymentID;
  	    }
      }
      $('#input-string').val(inputString);
							if ((selectedCreditCardRadio && ($(".guest-credit-card-list input:radio:first").prop("checked")) &&
												(selectedCreditCardRadio.data('ispreferred') || selectedCreditCardRadio.data('preselectedcard'))) || isPreferredSelected) {
										$('#is-preferred').val(true);
							}  else{
										$('#is-preferred').val(false);
							}
  },

/** toggle preferred value based on make 'my preferred card' checkbox selection and to set/reset input string value each time user clicks **/
			togglePreference: function _togglePreference(){
					 var _self = this;
					 $('#is-preferred').val($('#isPreferredSelected').prop("checked"));
					_self.setInputString();
			},

/**
  * saveCreditCardHandler
  * @method saveCredditCardHandler
  * @return {[void]}
  */
  saveCreditCardHandler: function _saveCreditCardHandler() {
    var _self = this;
    var maskedCardNumber = $('.guest-credit-card-list input:checked').data('masked-number');
        var num = $("#credit-card-number").val();
	var saveblePreferenceMsgDiv = $('#creditCardSavebleMsgDiv');
	var showSection = $('.js-credit-card-tile').data('creditcardshowsection');
	if(num.length >= 4 && ($('.guest-credit-card-add input').prop("checked") != true)){
		num = num.slice(-4);
		if ((maskedCardNumber && maskedCardNumber.includes(num)) || (showSection == false)) {
			saveblePreferenceMsgDiv.show();
		} else {
			saveblePreferenceMsgDiv.hide();
			$('#saveCreditCardField').prop("checked", false);
		}
	 } else if ($('#alternateCreditCard').prop("checked")){
		saveblePreferenceMsgDiv.show();
	 } else {
		saveblePreferenceMsgDiv.hide();
		$('#saveCreditCardField').prop("checked", false);
	 }
  },

  showAllCards: function _showAllCards() {
  var _self = this;
    $('.hidden-div').removeClass('l-display-none');
    $('.js-close').removeClass('l-display-none');
    $('.js-show-more').addClass('l-display-none');
  _self.toggleFrameHeight();
  },

  collapseCards: function _collapseCards() {
  var _self = this;
    $('.hidden-div').addClass('l-display-none');
    $('.js-close').addClass('l-display-none');
    $('.js-show-more').removeClass('l-display-none');
  _self.toggleFrameHeight();
  },

  defObj: {},
  config: {
    fieldsValue: {},
    ccSectionVisible: false,
    collapseFlag: true
  },
  subscribe: {
    'CREDITCARD_REFRESH': 'compRefresh',
    'USER_INFO_MOD': 'populateCardHolderName',
    'CREDITCARD_PP_OVERRIDE': 'showPPOverride',
    'TOGGLE_MESSAGE_E_CERTIFICATE': 'toggleECertificateMessage',
    'CREDITCARD_TOGGLE': 'toggleCreditCardSection',
    'TOGGLE_CREDITCARD_VISA_CONTAINER': 'ccByPassToggleSection',
    'CREDIT_CARD_WIDGET_REFRESH': 'refresh',
    'TO_IFRAME_GET_CC_DATA': 'postFrameFormFields',
    'TO_IFRAME_TOGGLE_PAYMENT_OPTION': 'togglePaymentOptionHandler',
    'TO_IFRAME_TOGGLE_PAYMENT_TAB': 'togglePaymentOptionTab',
    'TO_IFRAME_SET_FORM_DATA': 'formSubmitHandler',
    'TO_IFRAME_SET_PREFERENCE_PLUS': 'showPPOverride',
    'TO_IFRAME_SET_SHOW_FLAG': 'toggleCreditCardChargeMsg',
    'TO_IFRAME_TOGGLE_CC_CHARGE_MESSAGE': 'toggleCCChargeMessage',
    'TO_IFRAME_SET_PURCHASE_POINTS_FLAG': 'getCCCardMessageHandler',
    'CHECK_IF_CREDITCARD_VISIBILITY_FROM_EDIT': 'getIsCreditCardVisibleFromEdit',
    'CHECK_IF_CREDITCARD_VISIBILITY_FROM_TOGGLE': 'getIsCreditCardVisibleFromToggle',
    'SHOW_CREDITCARD': 'showCreditCard',
    'BOOKNOW_LOADED': 'setCCLoaded',
     'QG_FORM_LOADED': 'setCCLoaded',
   'FROM_IFRAME_REGISTER_POP_UP': 'registerCCPopUp',
   'PAYMENT_METHOD_ACTIVITY': 'creditCardInfoChanged'
  },

  toggleFrameHeight: function(){
    var _self = this;
     _self.pubsub.publish('FROM_IFRAME_SET_HEIGHT');
  },

  showCreditCard: function(){
    var _self = this;
    $('.js-credit-card-form').removeClass('is-hidden');
    $("#credit-card-section .js-toggle-arrow").removeClass("t-icon-arrow-down").addClass("t-icon-arrow-up");
    _self.getIsCreditCardVisibleFromToggle();
  },

  getIsCreditCardVisibleFromEdit : function(){
    var _self = this;
    _self.pubsub.publish('REVERT_CC_VISIBILITY_STATUS_ONEDIT',[$('.js-credit-card-form').hasClass('is-hidden')]);
  },

  getIsCreditCardVisibleFromToggle : function(){
    var _self = this;
    _self.pubsub.publish('REVERT_CC_VISIBILITY_STATUS_ONTOGGLE',[$('.js-credit-card-form').hasClass('is-hidden')]);
  },

  displayCreditCardFormFromFile: function() {
    var _self = this;

    if ($('#display-credit-from-file-hidden').val() === 'true') {
      _self.defObj.nameOnCC.hide();
    } else {
      _self.defObj.nameOnCC.show();
    }

    if (_self.defObj.selectCreditCard.length && _self.defObj.selectCreditCard.val() === 'E') {
      _self.defObj.ccNickNameAndPurpose.hide();
      _self.defObj.nameOnCC.show();
    }

    if (_self.defObj.saveCreditCardFieldObj.length && _self.defObj.saveCreditCardFieldObj.is(':checked')) {
      _self.savableCreditCardInfoChanged();
    }
  },

  bindCreditCardEvents: function() {
    var _self = this;
    if (_self.defObj.billingFormElementsChange.length) {
      _self.$(_self.defObj.billingFormElementsChange).on('change', _self.savableCreditCardInfoChanged.bind(_self));
    }

    if (_self.defObj.billingFormElementsPressed.length) {
      _self.defObj.billingFormElementsPressed.on('keydown', _self.savableCreditCardInfoChanged.bind(_self));
    }

    if (_self.defObj.purposeElements.length) {
      _self.defObj.purposeElements.on('click', _self.savableCreditCardInfoChanged.bind(_self));
    }

    if (_self.defObj.usePreferencePlus.length && _self.defObj.usePreferencePlus.is(':checked')) {
      _self.defObj.saveblePreferenceMsgDiv.hide();
    }

    _self.defObj.usePreferencePlus.on('click', function() {
      if (_self.defObj.saveblePreferenceMsgDiv.length) {
        if (_self.defObj.saveCreditCardFieldObj.length) {
          _self.defObj.saveCreditCardFieldObj.attr('checked', false);
        }
        _self.defObj.saveblePreferenceMsgDiv.hide();
      }
    });
      _self.getIsCreditCardVisibleFromToggle();
      _self.pubsub.publish('FROM_IFRAME_SET_HEIGHT');
  },

  bindFormSubmit: function() {
    var _self = this;
       if(_self.defObj.selectedCreditCardBlock.length) {
      _self.defObj.selectedCreditCardBlock.on('click', function($target){
        //handle switch selectedCreditCardBlock
        var creditCardNickName = $('#credit-card-nickname'),
          creditCardType = $('#credit-card-type-hidden'),
          creditCardNumber = $('#credit-card-number'),
          expMonth = $('#exp-month'),
          expYear = $('#exp-year'),
          expDate = $('#exp-date'),
          paymentMethodId;
      if($('#selected-card-paymentMethodId')) {
        paymentMethodId = $('#selected-card-paymentMethodId');
      } else  {
        paymentMethodId = $('.l-preferred-card').data('payment-id');
      }

         var selectedAlias = $(this).attr('data-card-alias'),
          selectedCreditCardType =  $(this).attr('data-card-img-css'),
          selectedCreditCardIsPreferred = $(this).attr('data-isPreferred'),
          selectedCreditCardNumber = $(this).attr('data-card-number'),
          selectedExpMonth = $(this).attr('data-card-exp-month'),
          selectedExpYear = $(this).attr('data-card-exp-year'),
          selectedExpDate = $(this).attr('data-card-exp-date'),
          selectedPurpose = $(this).attr('data-card-purpose'),
										selectedTokenPan = $(this).attr('data-token-pan-no'),
          selectedPaymentMethodId = $(this).attr('data-payment-id');

								 tokenizedPanNumber.val(selectedTokenPan);
         creditCardNickName.val(selectedAlias);
        creditCardType.val(selectedCreditCardType);
        creditCardNumber.val(selectedCreditCardNumber);
        if(selectedPaymentMethodId && !($('.guest-credit-card-list input:checked').data("expiredcreditcard"))) {
          paymentMethodId.val(selectedPaymentMethodId);
        } else {
									 paymentMethodId.val('');
								}
        expMonth.val(selectedExpMonth);
        _self.setSelectedOption(expMonth, selectedExpMonth);
        expYear.val(selectedExpYear);
        _self.setSelectedOption(expYear, selectedExpYear);
         expDate.val(selectedExpDate);
        _self.setSelectedOption(expDate, selectedExpDate);
        _self.$(_self.$el).trigger('GLOBAL_ELEMENTS_REINIT.mi-select');
        _self.$el.find('#purpose input[name="purpose"][value="' + selectedPurpose + '"]').prop('checked', true);
        _self.setCvvMaxLength();
        _self.toggleCVV();
      });
    }
    if (_self.defObj.selectedCreditCard.length) {
      _self.defObj.selectedCreditCard.on('click', function($target) {
        //handle switch selectedCreditCard
        var creditCardNickName = $('#credit-card-nickname'),
          checkedCreditCardValue = $(this).val(),
          creditCardType = $('#credit-card-type-hidden'),
          creditCardNumber = $('#credit-card-number'),
          expMonth = $('#exp-month'),
          expYear = $('#exp-year'),
          expDate = $('#exp-date'),
          paymentMethodId,
										tokenizedPanNumber=$('.guest-credit-card-list input:checked').data('tokenized-pan-number'),
	  							creditCardMask = $('.guest-credit-card-list input:checked').attr('data-card-number'),
          encodedPaymentMethodData = $('.guest-credit-card-list input:checked').data('encoded-payment-method-data');

	  $('#credit-card-mask').val(creditCardMask);
		 if($('#selected-card-paymentMethodId')) {
    paymentMethodId = $('#selected-card-paymentMethodId');
  } else  {
    paymentMethodId = $('.guest-credit-card-list input:checked').data('payment-id');
  }
  if($('#encoded-payment-method-data') && (!($('.guest-credit-card-list input:checked').data("expiredcreditcard")))) {
    $('#encoded-payment-method-data').val(encodedPaymentMethodData);
  } else {
			$('#encoded-payment-method-data').val('');
		}
		if($('#tokenized-pan-number')) {
    $('#tokenized-pan-number').val(tokenizedPanNumber);
  }
							var cobrandIssuerCode = $('#cobrand-issuer-code');
							var cobrandIssuerCodeValue = cobrandIssuerCode.data('cobrand-issuer-code');
		if($('.guest-credit-card-list input:checked').data("new-cobrand-card")){
			 cobrandIssuerCode.val(cobrandIssuerCodeValue);
		} else {
			 cobrandIssuerCode.val('');
		}
        _self.defObj.ccNickNameAndPurpose.show();
        _self.defObj.nameOnCC.hide();

        var selectedAlias = '',
          selectedCreditCardType = '',
          selectedCreditCardNumber = '',
          selectedExpMonth = '',
          selectedExpYear = '',
          selectedExpDate = '',
          selectedPurpose = '',
										selectedTokenPan='',
          selectedPaymentMethodId = '',
          selectedEncodedPaymentMethodData = '';

        if (checkedCreditCardValue === 'selectedCreditCard'){
            selectedAlias = $(this).attr('data-card-exp-year');
            selectedCreditCardType = $(this).attr('data-card-img-css');
            selectedCreditCardIsPreferred = $(this).attr('data-isPreferred');
            selectedCreditCardNumber = $(this).attr('data-masked-number');
            selectedExpMonth = $(this).attr('data-card-exp-month');
            selectedExpYear = $(this).attr('data-card-exp-year');
            selectedExpDate = $(this).attr('data-card-exp-date');
            selectedPurpose = $(this).attr('data-card-purpose');
												 selectedTokenPan = $(this).data('tokenized-pan-number');
            selectedEncodedPaymentMethodData = $(this).data('encoded-payment-method-data');
	    selectedPaymentMethodId = $(this).attr('data-payment-id');
									  if (_self.defObj.initialSelectedCardValue === 'selectedCreditCard'){
												_self.defObj.paymentMethodIdUpdated.val(_self.defObj.initialSelectedCardValue === checkedCreditCardValue);
				 						}
											if (_self.defObj.initialSelectedCardValue === 'E'||_self.defObj.initialSelectedCardValue === 'A'){
											_self.defObj.paymentMethodIdUpdated.val(_self.defObj.initialSelectedCardValue !== checkedCreditCardValue);
											}
        	}

          if (checkedCreditCardValue === 'P') {
            selectedAlias = $('#preferred-card-alias').val();
            selectedCreditCardType = $('#preferred-card-vendor-code').val();
            selectedCreditCardNumber = $('#preferred-card-number').val();
            selectedExpMonth = $('#preferred-card-exp-month').val();
            selectedExpYear = $('#preferred-card-exp-year').val();
            selectedExpDate = $('#preferred-card-exp-date').val();
            selectedPurpose = $('#preferred-card-purpose').val();
            selectedPaymentMethodId = $('#preferred-card-payment-method-id').val();
          } else if (checkedCreditCardValue === 'O') {
            selectedAlias = $('#other-card-alias').val();
            selectedCreditCardType = $('#other-card-vendor-code').val();
            selectedCreditCardNumber = $('#other-card-number').val();
            selectedExpMonth = $('#other-card-exp-month').val();
            selectedExpYear = $('#other-card-exp-year').val();
            selectedExpDate = $('#other-card-exp-date').val();
            selectedPurpose = $('#other-card-purpose').val();
            selectedPaymentMethodId = $('#other-card-payment-method-id').val();
          }
         else if (checkedCreditCardValue === 'E' || checkedCreditCardValue === 'A') {
										 if (_self.defObj.initialSelectedCardValue === 'selectedCreditCard'){
												_self.defObj.paymentMethodIdUpdated.val(_self.defObj.initialSelectedCardValue !== checkedCreditCardValue);
											}
										if (_self.defObj.initialSelectedCardValue === 'E'||_self.defObj.initialSelectedCardValue === 'A'){
											_self.defObj.paymentMethodIdUpdated.val(_self.defObj.initialSelectedCardValue === checkedCreditCardValue);
											}
          if (checkedCreditCardValue === 'E') {
            _self.defObj.ccNickNameAndPurpose.hide();
            _self.defObj.nameOnCC.show();
            if (_self.defObj.saveCreditCardFieldObj.length) {
              _self.defObj.saveCreditCardFieldObj.attr('checked', false);
            }
            if (_self.defObj.saveblePreferenceMsgDiv.length) {
              _self.defObj.saveblePreferenceMsgDiv.hide();
            }

          }
          _self.defObj.cvvTextBox.val('').show();
          selectedPurpose = 'B';
          var hiddenCreditCard = $('#new-card-number');
          var alternateCard = $('#is-alternate-card').val();
										if(alternateCard === 'false') {
											 selectedAlias = '';
            selectedCreditCardType = '';
            selectedCreditCardNumber = '';
            selectedExpMonth = '';
            selectedExpYear = '';
            selectedExpDate = '';
            selectedPurpose = '';
            selectedPaymentMethodId = '';
										}
          else if (hiddenCreditCard.length) {
            selectedAlias = $('#new-card-alias').val();
            selectedCreditCardType = $('#new-card-vendor-code').val();
            selectedCreditCardNumber = $('#new-card-number').val();
            selectedExpMonth = $('#new-card-exp-month').val();
            selectedExpYear = $('#new-card-exp-year').val();
            selectedExpDate = $('#new-card-exp-date').val();
            selectedPurpose = $('#new-card-purpose').val();
            selectedPaymentMethodId = $('#new-card-payment-method-id').val();
          }
        }
        creditCardNickName.val(selectedAlias);
        creditCardType.val(selectedCreditCardType);
        if (creditCardType.val() !== '') {

          var $selectedCreditCard = $('#credit-card-type li img#' + selectedCreditCardType);
          var altText = '';

          $('#credit-card-type li img').each(function() {
            altText = $(this).data('options').accept;
            $(this).removeClass('unselected').addClass('unselected').attr('title', altText+" ").attr('alt', altText);
          });

                   if($selectedCreditCard.length) {
            altText = $selectedCreditCard.data('options').selected;
            $selectedCreditCard.removeClass('unselected').attr('title', altText+" ").attr('alt', altText);
                    }

          if (_self.$el.find('.cc-image-inline').length) {
            $('#credit-card-type li').addClass('unselected');
                       if($selectedCreditCard.length) {
               $selectedCreditCard.parents('li').removeClass('unselected');
                        }
          }

        } else {

          $('#credit-card-type li img').each(function() {
            var altText = $(this).data('options').accept;
            $(this).removeClass('unselected').attr('title', altText+" ").attr('alt', altText);
          });
          _self.$el.find('.cc-image-inline #credit-card-type li').addClass('unselected');
        }
        if(selectedCreditCardNumber !== '' ){
          creditCardNumber.attr('readonly', true);
        }
        else{
          creditCardNumber.attr('readonly', false);
        }
	_self.enableAlternateCard();
	creditCardNumber.val(selectedCreditCardNumber);
	/** Added the following if cond to set preferred value and check the checkbox based on selected card **/
	if((selectedCreditCardNumber !== "" && selectedCreditCardIsPreferred !== undefined) && ($('#makePrimaryCard').data('masked-number') === selectedCreditCardNumber ||  selectedCreditCardIsPreferred == "true" )){
					$('#isPreferredSelected').prop("checked", true);
						$('#is-preferred').val(true);
	} else {
					$('#isPreferredSelected').prop("checked", false);
					$('#is-preferred').val(false);
	}
	_self.setInputString();
	if(selectedPaymentMethodId) {
          paymentMethodId.val(selectedPaymentMethodId);
  } else {
    paymentMethodId.val($('.guest-credit-card-list input:checked').data('payment-id'));
  }
  if(selectedEncodedPaymentMethodData && (!($('.guest-credit-card-list input:checked').data("expiredcreditcard")))) {
      $('#encoded-payment-method-data').val(selectedEncodedPaymentMethodData);
  } else {
			   $('#encoded-payment-method-data').val('');
		}
		if(selectedTokenPan) {
      $('#tokenized-pan-number').val(selectedTokenPan);
  }
        expMonth.val(selectedExpMonth);
        _self.setSelectedOption(expMonth, selectedExpMonth);
        expYear.val(selectedExpYear);
        _self.setSelectedOption(expYear, selectedExpYear);
        expDate.val(selectedExpDate);
        _self.setSelectedOption(expDate, selectedExpDate);
        _self.$(_self.$el).trigger('GLOBAL_ELEMENTS_REINIT.mi-select');
        _self.$el.find('#purpose input[name="purpose"][value="' + selectedPurpose + '"]').prop('checked', true);
        _self.setCvvMaxLength();
        _self.toggleCVV();
        _self.pubsub.publish('FROM_IFRAME_SET_HEIGHT');
      });
    }

    _self.$(_self.$el.find('#credit-card-number, #exp-month, #exp-year')).on('change', function() {
      var $creditCardFields = _self.$el.find('#credit-card-number');
      if ($creditCardFields.val() === _self.$el.find('#credit-card-mask').val() && _self.$el.data('isuserauthenticated')) {
        $creditCardFields.val('');
      }

      _self.$el.find('#selected-card-paymentMethodId').val('');
      $('#encoded-payment-method-data').val('');
      _self.toggleCVV();
      _self.pubsub.publish('FROM_IFRAME_SET_HEIGHT');
      
      //check modification type and publish it for click tracking
      _self.creditCardInfoChanged();
    });

    _self.defObj.creditCardChargeMsg.hide();

    _self.pubsub.publish('FROM_IFRAME_GET_CC_CARD_SHOW_FLAG');

    //Display USD will be charged to this credit card to purchase # points message
    _self.pubsub.publish('FROM_IFRAME_BIND_CLICK_EVENT');

    //to hide continue button when only have purchase points check box as payment selection

    this.pubsub.publish('FROM_IFRAME_TOGGLE_SUBMIT_BUTTON');

    //When purchase point checkbox clicked
    this.pubsub.publish('FROM_IFRAME_BIND_PURCHASE_POINTS_CHECKBOX');
    _self.setCvvMaxLength();
    _self.toggleCVV();
  },

  toggleCreditCardChargeMsg: function _toggleCreditCardChargeMsg() {
    if(showFlag) {
      this.defObj.creditCardChargeMsg.show();
    } else {
      this.defObj.creditCardChargeMsg.hide();
    }
  },

  bindEvents: function(jquery) {
    var _self = this,
      cvvTextBox,
      whyWeAskPopUpTriggerer,
      whySaveMyChangesPopUpTriggerer;

    var $window = $(window);
    this.showAllCards.bind(this);
    this.collapseCards.bind(this);
    $window.on("load", function(event) {
					_self.pubsub.publish('FROM_IFRAME_SET_HEIGHT');
					if($('#credit-card-section').data('isuserauthenticated')) {
							var text =""
							if($('.guest-credit-card-add input:checked').length) {
								text = text + "AC";
							}
							if($('.guest-credit-card-list input:checked').length) {
								text = text + "SC";
							}
							if($('#purpose input[name=purpose]:checked').length) {
								if($('#purpose input[name=purpose]:checked')[0] && $('#purpose input[name=purpose]:checked')[0].id) {
									text = text +  $('#purpose input[name=purpose]:checked')[0].id.substring(0,1);
								}
							}
							if(_self.$el.find('.t-form-error-frame').length) {
								text = text + "E" + _self.$el.find('.t-form-error-frame').length;
							}
							console.error("VOC Initial " + text);
					}
    });

    //Onload set values when v3 flag is on
    if($('.js-credit-card-tile').data('show-all-cards') === true) {
	    if($('.guest-credit-card-add input:checked').val() == "A" || $('.guest-credit-card-add input:checked').val() == "E") {
		$('#credit-card-number').attr('readonly', false);
		$('#tokenized-pan-number').val('');
		$('#encoded-payment-method-data').val('');
	    }
	    //Setting inputString(number andd addCardSelected)
	   _self.setInputString();
	   _self.$el.find('#credit-card-number').on('blur', _self.setInputString.bind(_self));

	   var selectedCreditCardRadio = $('.guest-credit-card-list input:checked');
	   if(selectedCreditCardRadio.val()) {
		$('#tokenized-pan-number').val(selectedCreditCardRadio.data('tokenized-pan-number'));
		if(selectedCreditCardRadio.data("expiredcreditcard")){
			$('#encoded-payment-method-data').val('');
		}
 	   }
	   else {
		$('#tokenized-pan-number').val('');
		$('#encoded-payment-method-data').val('');
	   }
	   if(selectedCreditCardRadio.data('ispreferred')){
	   	$('#isPreferredSelected').prop("checked", true);
	   }
    }

      var _indexCard= $('#select-credit-card .preselectCard').index();
    if (_indexCard > 3) {
      $('.hidden-div').removeClass('l-display-none');
      $('.js-close').removeClass('l-display-none');
      $('.js-show-more').addClass('l-display-none');
    }
				if($('#credit-card-section').data('isuserauthenticated')) {
									console.error("VOC Loaded");
				}
    _self.pubsub.publish('FROM_IFRAME_CC_LOADED');
    var mainWindow = window.parent.document.body;
    var savedCardDetailsPopup = new Popup({
        selector: '.tile-credit-card-review-details .mi-popover',
        sourceBlock: '.modal-content',
        alternateCloseMarkup: true
    });
    savedCardDetailsPopup.register();

    //adding external jquery to scope for referencing selectric elements
    _self.$ = jquery;
    _self.keyExclusionList = [
      Constants.GLOBAL.TAB,
      Constants.GLOBAL.ENTER,
      Constants.GLOBAL.SHIFT,
      Constants.GLOBAL.CTRL,
      Constants.GLOBAL.ALT,
      Constants.GLOBAL.CAPS,
      Constants.GLOBAL.ESC,
      Constants.GLOBAL.PAGE_UP,
      Constants.GLOBAL.PAGE_DOWN,
      Constants.GLOBAL.ARROW_LEFT,
      Constants.GLOBAL.ARROW_UP,
      Constants.GLOBAL.ARROW_RIGHT,
      Constants.GLOBAL.ARROW_DOWN
    ];
    _self.isCreditCardDisabled = false;
    _self.isFreshLoad();
    if (_self.$el.data('bypassccapplicable') && _self.config.ccSectionVisible) {
      _self.$el.show();
    }

    cvvTextBox = _self.defObj.cvvTextBox;

    _self.$el.find('.js-close-button').on('click', function(e){
      e.preventDefault();
      _self.refresh({},function(){
        _self.pubsub.publish('FROM_IFRAME_SET_HEIGHT');
      });
    });

    _self.$el.find('.t-cc-form-shield-dismiss').on('click', function() {
      _self.pubsub.publish('CREDITCARD_PP_REMOVE_OVERRIDE');
      _self.showPPOverride(false);
      _self.pubsub.publish('FROM_IFRAME_SET_HEIGHT');
    });
    if ($('#credit-card-section').length) {
      var $cardNumber = $('#credit-card-number');
      $cardNumber.attr('autocomplete', 'off');
      $cardNumber.attr('pattern', '[0-9]*');
      _self.defObj.saveblePreferenceMsgDiv.hide();
      //Initialize credit card type
      _self.initializeCardType();
      _self.displayCreditCardFormFromFile();
      _self.bindCreditCardEvents();
      // handle display save credit card preference checkbox .
      _self.defObj.preferCredit = $('#preferredCreditCard');
      //insert preferred credit card radio button
      if (_self.defObj.preferCredit.length) {
        _self.defObj.preferCredit.removeClass('hidden');
      }
      //insert other credit card radio button
      _self.defObj.otherCredit = $('#otherCreditCard');
      if (_self.defObj.otherCredit.length) {
        _self.defObj.otherCredit.removeClass('hidden');
      }

      //insert entered credit card radio button
      _self.defObj.enterCredit = $('#enterCreditCard');
      if (_self.defObj.enterCredit.length) {
        _self.defObj.enterCredit.removeClass('hidden');
      }

      //insert alternated credit card radio button
      _self.defObj.alternateCredit = $('#alternateCreditCard');
      if (_self.defObj.alternateCredit.length) {
        _self.defObj.alternateCredit.removeClass('hidden');
      }

      //when click on  selected radio button, copy all the field values to form
      _self.bindFormSubmit();
    }

    this.pubsub.publish('FROM_IFRAME_GET_PREFERENCE_PLUS_VALUE', [$('#credit-card-section').length]);
				_self.isPasted = false;
    _self.initializeCardType();
    _self.$el.find('#credit-card-number').on('keyup', function(event) {
						_self.isPasted = ((event.key == "Meta" || event.key == "Control") && (event.keyCode == 91 || event.keyCode == 17 || event.keyCode == 224)) ? true : false
      if (($('#credit-card-number').val() !== $('#credit-card-mask').val()) || ($('#credit-card-mask').val() == '' && $('#credit-card-number').val() == '') ) {
        _self.populateCreditCardType();
        _self.setCvvMaxLength();
      } else {
        var ccTypeSelected = '';
        if ($('#credit-card-type li img.unselected').length) {
          ccTypeSelected = $('#credit-card-type li img').not('.unselected').attr('id');
        }
        if (ccTypeSelected !== $('#credit-card-type-hidden').val() || $('#credit-card-number').val() === '') {
          $('#credit-card-type li img').removeClass('unselected');
          $('#credit-card-type li').addClass('unselected');
        }
      }
      /**
       * This condition is handling the exclusion list of keys for #credit-card-number section keyup event
       * All the keys defined in Constants file in lib
       */
      if (_self.keyExclusionList.indexOf(event.which) < 0 && event.which !== Constants.GLOBAL.BLUR) {
        _self.$el.find('#selected-card-paymentMethodId').val('');
        _self.$el.find('.inline-error').addClass('is-hidden');
        _self.$el.find('#credit-card-type').removeClass('is-hidden');
        _self.toggleCVV();
      }
      _self.setCardInfoChangedFlag($(event.target));
      _self.pubsub.publish('FROM_IFRAME_SET_HEIGHT');

	_self.saveCreditCardHandler();
    });

    _self.$el.find('#exp-date').on('keydown blur', function(event) {

    		var	monthRegex= /^\d\d$/,
    						isMonthEntered = monthRegex.exec(event.target.value);

          if (event.key >= 0 && event.key <= 9 && isMonthEntered) {
            event.target.value = event.target.value + "/";
          }
    });

    _self.$el.find('#exp-date').on('keypress', function(event) {
       	return event.charCode >= 48 && event.charCode <= 57;
    });

    cvvTextBox.on('keydown', _.bind(_self.cvvKeypressHandler, _self));
    cvvTextBox.on('paste', _.bind(_self.cvvPasteHandler, _self));


    whyWeAskPopUpTriggerer = _self.$el.find('a.js-credit-card-popover');
    whySaveMyChangesPopUpTriggerer = _self.$el.find('#creditCardSavebleMsgDiv a.mi-popover');

//    _self.pubsub.publish('FROM_IFRAME_REGISTER_POP_UP', [{
//      url: whyWeAskPopUpTriggerer.attr('href'),
//      selector: 'a.js-credit-card-popover',
//      sourceBlock: '.modal-content',
//      alternateCloseMarkup: true
//    }]);

    _self.pubsub.publish('FROM_IFRAME_REGISTER_POP_UP', [{
      url: whySaveMyChangesPopUpTriggerer.attr('href'),
      selector: '#creditCardSavebleMsgDiv a.mi-popover',
      sourceBlock: '.modal-content',
      removeScriptTags: true,
      alternateCloseMarkup: true
    }]);


//    whyWeAskPopUpTriggerer.on('click', function(event){
//      event.preventDefault();
//    });

    whySaveMyChangesPopUpTriggerer.on('click', function(event){
      event.preventDefault();
    });

    _self.$el.find('.js-edit-text').off('click').on('click', function(e) {
      e.preventDefault();
      var $obj = $(this);
      if(!$('.js-credit-card-form').hasClass('is-hidden')){
        _self.compRefresh();
      } else {
        _self.pubsub.publish('EDIT_CLOSE_CLICK', [{selector:true}]);
      }
      $('.js-saved-card-toggle').addClass('is-hidden ');
      _self.$(_self.$el).trigger('GLOBAL_ELEMENTS_REINIT.mi-select');
            setTimeout(function() {
              _self.pubsub.publish('FROM_IFRAME_SET_HEIGHT');
            }, 1000);
    });

    _self.$el.find('#submit-guest-credit-card').off('click').on('click', function(e) {
      e.preventDefault();
      _self.setInputString();
      _self.compRefresh();
      _self.pubsub.publish('FROM_IFRAME_SET_HEIGHT');
      return false;
    });
    if (_self.$el.data('error') === 'true' || _self.$el.data('error') === true) {
      $('.js-credit-card-form').removeClass('is-hidden');
      $('.js-saved-card-toggle').addClass('is-hidden ');
      $('.js-confrim-details-form').removeClass('is-hidden');
      _self.pubsub.publish('ERRORMSG_REFRESH');
    }
    // AAB-44 : Execute when its signed In user, profile saved primarycard not accepted at property
    if(_self.$el.data('isuserauthenticated') && _self.$el.data('show-all-cards') && _self.$el.data('creditcardshowsection')
    		&& _self.$el.data('isprimarycardaccepted') == false) {
    		if(!_self.defObj.initialSelectedCardValue) {
							  // Expand credit card section
									$('.js-credit-card-form').removeClass('is-hidden');
									$('.js-saved-card-toggle').addClass('is-hidden ');
									$('.js-confrim-details-form').removeClass('is-hidden');
									$('.js-primary-card-not-accepted-message').removeClass('is-hidden');
									// Make Alternate creditcard radio selection
									if($('#alternateCreditCard').length) {
										$('#alternateCreditCard').click();
									} else {
										$('#enterCreditCard').click();
									}
									// scroll down the page to credit card section
									$('html,body', window.parent.document).animate({scrollTop: window.parent.$('.pci-data-frame-container').offset().top-150}, 1000);
						} else {
									$('.js-primary-card-not-accepted-message').addClass('is-hidden');
						}
    }
     _self.creditCardInfo(_self.defObj.expMonth, _self.defObj.expMonthDropDown);
    _self.creditCardInfo(_self.defObj.expYear, _self.defObj.expYearDropDown);
    _self.$el.find('noscript').remove();

    _self.$el.find('.payment-option-toggle , .payment-option-toggle label').on('click', function(e) {
      _self.config.collapseFlag = !_self.config.collapseFlag;
      _self.togglePaymentOptionSection($(this));
    });
    _self.$el.find('select').on('click blur', function(e) {
      if (e.type === 'click') {
        $(this).siblings('.m-dropdown-trigger').toggleClass('dropdown-is-active');
      } else {
        $(this).siblings('.m-dropdown-trigger').removeClass('dropdown-is-active');
      }
    });
    _self.pubsub.publish('FROM_IFRAME_SET_HEIGHT');

    $('#credit-card-section').on('load', function () {
      //on type of payment type selection; determine type of modification
      $('input[type=radio][name=selectedCreditCard]').on('change', function () {
        _self.creditCardInfoChanged();
      });
      //determine initial payment type selection
      _self.creditCardInfoChanged();      
    })
      //Setting fraudError key for error tracking
      var errorKey = $('input[name=fraudErrorKey]').val();
      if (errorKey.length) {
        window.parent.customAnalyticsCall("evar32=" + errorKey + "^event166");
      }
    
  },

  creditCardInfo: function($obj, $dropDown) {
    var _self = this;
    $obj.on('click', function(e) {
      e.preventDefault();
      var activeParent = $obj.parent('li.is-active');
      var mainContainer = $(this).parent('li');
      var dropDownValue = $(this).attr('data-date');
      activeParent.removeClass('is-active');
      mainContainer.addClass('is-active');
      $dropDown.find('option').removeAttr('selected', 'true');
      $dropDown.find('option[value="' + dropDownValue + '"]').prop('selected', true);
      _self.pubsub.publish('FROM_IFRAME_SET_HEIGHT');
    });
    $dropDown.on('change', function(event) {
      _self.dropdownToTabBinding($obj, $dropDown);
      _self.setCardInfoChangedFlag($(event.target));
      _self.pubsub.publish('FROM_IFRAME_SET_HEIGHT');
    });
  },

  dropdownToTabBinding: function($obj, $dropDown) {
    $obj.parent('li').removeClass('is-active');
    $obj.filter('[data-date="' + $dropDown.find('option:selected').val() + '"]').parent('li').addClass('is-active');
  },

  populateCardHolderName: function(name) {
    if (name.firstName.length !== 0 && name.lastName.length !== 0 && !(this.$el.hasClass('tile-credit-card-quick-groups'))) {
      var cardHolderNameLang = $('html').attr('lang');
      if (cardHolderNameLang === 'zh-CN' || cardHolderNameLang === 'ja-JP') {
        this.$el.find('#credit-card-name').val(name.lastName + ' ' + name.firstName);
      } else {
        this.$el.find('#credit-card-name').val(name.firstName + ' ' + name.lastName);
      }
    }
  },

  isFreshLoad: function() {
    var _self = this;
    _self.defObj.saveblePreferenceMsgDiv = $('#creditCardSavebleMsgDiv');
    _self.defObj.nameOnCC = $('#name-on-cc');
    _self.defObj.ccNickNameAndPurpose = $('#cc-nick-name, #purpose');
    _self.defObj.usePreferencePlus = $('#use-preference-plus');
    _self.defObj.creditCardChargeMsg = $('#credit-card-charge-message');
    _self.defObj.purchasePoints = $('#purchase-points');
    _self.defObj.selectedCreditCardType = $('#credit-card-type-hidden');
    _self.defObj.selectCreditCard = $('#select-credit-card input[name=selectedCreditCard]');
    _self.defObj.saveCreditCardFieldObj = $('#saveCreditCardField');
    _self.defObj.billingFormElementsChange = $('#exp-month, select#exp-year');
    _self.defObj.billingFormElementsPressed = $('#credit-card-nickname, #credit-card-number');
    _self.defObj.purposeElements = $('#purpose input[name=purpose]');
    _self.defObj.creditCardInvalidMsg = $('input[name=invalidCCNameText]');
    _self.defObj.creditCardNickInvalidMsg = $('input[name=invalidCCNameMsg]');
    _self.defObj.selectedCreditCard = $('#select-credit-card input[name=selectedCreditCard]');
    _self.defObj.purchasePointsCheckBox = $('#redemption-payment-options #purchase-points-check');
    _self.defObj.$bothForms = $('#credit-card-section,#enrollment-billing-section');
    _self.defObj.expMonth = _self.$el.find('.l-exp-month-tab a');
    _self.defObj.expYear = _self.$el.find('.l-exp-year-tab a');
    _self.defObj.expMonthDropDown = _self.$(_self.$el.find('.js-exp-month'));
    _self.defObj.expYearDropDown = _self.$(_self.$el.find('.js-exp-year'));
    _self.defObj.cvvTextBox = _self.$el.find('.cvv-text-box');
    _self.defObj.paymentMethodIdUpdated = _self.$el.find('input[name="paymentMethodIdUpdated"]');
    _self.defObj.initialSelectedCardValue = _self.defObj.selectedCreditCard.filter(':checked').val();
       _self.defObj.selectedCreditCardBlock = $('.js-select-credit-card-block');
  },

  setSelectedOption: function(obj, value) {
    if (obj.find('option:selected').val() !== value) {
      obj.find('option').first().prop('selected', true);
    }
  },

  validateCCName: function() {
    var _self = this;
    var nameOnCreditCardObj = _self.$el.find('#credit-card-name');
    if (nameOnCreditCardObj !== null && nameOnCreditCardObj.length) {
      var nameOnCreditCard = nameOnCreditCardObj.val(),
        numbers = '0123456789',
        length = nameOnCreditCard.length;

      for (var i = 0; i < length; i++) {
        if (numbers.indexOf(nameOnCreditCard.charAt(i)) !== -1) {
          alert(_self.defObj.creditCardInvalidMsg.val());
          nameOnCreditCardObj.val('');
          setTimeout(function() {
            nameOnCreditCardObj.focus();
          }, 5);
          return false;
        }
      }
    }
    return true;
  },

  validateCCNickNameAndAlert: function() {
    var _self = this;
    var ccNickNameObj = _self.$el.find('#credit-card-nickname');
    //The alert should be dislayed if the length is > 14 and it contains only numbers with space(s) and hyphen(s) and not alpha numeric.
    if (ccNickNameObj.length && ccNickNameObj.val().length > 14) {
      var ccNickName = ccNickNameObj.val();
      var nameRegExp = /[A-Za-z]/;
      if (!nameRegExp.test(ccNickName)) {
        //Known issue here. When the user clicks on enter key after entering the cc# in the nick name field the alert message is displayed twice.
        //To avoid the double alerts, there was check for not displaying the alert in case of submit event. But, it caused an issue in production
        //where in, when the user had a cc nickname(actual credit card) on profile and tried to submit the form
        //without ever setting/losing focus on the Nickname field, the submit validation was failing and no error message was
        //presented to the user because of the check for event and hence the if check has been removed.
        alert(_self.defObj.creditCardNickInvalidMsg.val());
        ccNickNameObj.val('');
        setTimeout(function() {
          ccNickNameObj.focus();
        }, 5);
        return false;
      }
    }
    return true;
  },

  initializeCardType: function() {
    var $currentCreditCardType = $('#credit-card-type-hidden');
    var $creditCardNumber = $('#credit-card-number');
    var acceptedCreditCard = this.propertyAcceptedCreditCard();
    if ($currentCreditCardType.val() && $creditCardNumber.val() && $.inArray($currentCreditCardType.val(), acceptedCreditCard) >= 0) {
      var $selectedCreditCard = $('#credit-card-type li img#' + $currentCreditCardType.val());
      $('#credit-card-type li img').each(function() {
        var altText = $(this).data('options').accept;
        $(this).removeClass('unselected').addClass('unselected').attr('title', altText+" ").attr('alt', altText);
      });
      $selectedCreditCard.removeClass('unselected').attr('title', $selectedCreditCard.data('options').selected +" ").attr('alt', $selectedCreditCard.data('options').selected);
    }
  },

  populateCreditCardType: function() {
    var _self = this,
						ccVal = $('#credit-card-number').val().split(' ').join(''),
      ccLength = $('#credit-card-number').val().length,
      ccFound = false,
      Cards = this.cardType(),
      $currentCreditCardType = $('#credit-card-type-hidden'),
      altText;

    if (ccLength !== 0) {
      var cardNum, ccShort;
      var creditCardsTotal = Cards.length;
      for (var i = 0; i < creditCardsTotal; i++) {
        for (var n = 0; n < Cards[i][1].length; n++) {
          cardNum = Cards[i][1][n];
          ccShort = parseFloat(ccVal.substr(0, cardNum.toString().length));
          if ($.inArray(ccShort, Cards[i][1]) >= 0) {
            var acceptedCreditCard = this.propertyAcceptedCreditCard();
            if ($.inArray(Cards[i][3], acceptedCreditCard) >= 0) {
              var selectedCard = $('#credit-card-type li img#' + Cards[i][3]);
              altText = '';
              $('#credit-card-type li img').each(function() {
                altText = $(this).data('options').accept;
                $(this).removeClass('unselected').addClass('unselected').attr('title', altText + ' ').attr('alt', altText);
              });
              if (this.$el.find('.cc-image-inline').length) {
                this.$el.find('#credit-card-type li').addClass('unselected');
              }
              altText = selectedCard.data('options').selected;
              selectedCard.removeClass('unselected').attr('title', altText+' ').attr('alt', altText);
              selectedCard.parents('li').removeClass('unselected');
              $currentCreditCardType.val(Cards[i][3]);
              ccFound = true;
            }
            break;
          }
        }
      }
      if((selectedCard !== undefined)){
							_self.selectedCardType = (selectedCard.attr('id'));
								_self.creditCardFormat();
						}
    }

    if (!ccFound) {
      $('#credit-card-type li img').each(function() {
        altText = $(this).data('options').accept;
        $(this).removeClass('unselected').attr('title', altText+' ').attr('alt', altText);
        $currentCreditCardType.val('');
      });
      $('#credit-card-type li').addClass('unselected');
					_self.selectedCardType = "default"
    }
  },

  propertyAcceptedCreditCard: function() {
    var propertyCreditCardList = [];
    $('#credit-card-type li img').each(function() {
      propertyCreditCardList.push($(this).attr('id'));
    });
    return propertyCreditCardList;
  },

  cardType: function() {
    return [
      ['Mastercard', [51, 52, 53, 54, 55, 22, 23, 24, 25, 26, 27],
        [16], 'MC'
      ],
      ['Visa', [4],
        [16], 'VS'
      ],
      ['Amex', [34, 37],
        [15], 'AX'
      ],
      ['DinersClub', [30, 36, 38, 39],
        [14, 16], 'DC'
      ],
      ['Discover', [60110, 60112, 60113, 60114, 601174, 601177, 601186, 601187, 601188, 601189, 60119, 644, 65],
        [16], 'DS'
      ],
      ['JCB', [352, 353, 354, 355, 356, 357, 358],
        [16], 'JC'
      ],
      ['UnionPay', [62],
        [16], 'UP'
      ]
    ];
  },

	/************************AutoFormatCreditCard- START******************************************/

	creditCardFormat: function(){
		'use strict';
		var
			_self = this;
			_self.cardTypeObj = {
      				'VS' : {
      					autoFormat: true,
      					cCardType: 'Visa',
      					maxLength: 19,
      					pattern : '9999 9999 9999 9999'
      				},
      				'MC' : {
      					autoFormat: true,
      					cCardType: 'MasterCard',
      					maxLength: 19,
      					pattern : '9999 9999 9999 9999'
      				},
      				'AX' : {
      					autoFormat: true,
      					cCardType: 'Amex',
      					maxLength: 17,
      					pattern : '9999 999999 99999'
      				},
      				'DC' : {
      					autoFormat: true,
      					cCardType: 'DinersClub',
      					maxLength: 19,
      					pattern : '9999 9999 9999 9999'
      				},
      				'DS' : {
      					autoFormat: true,
      					cCardType: 'Discover',
      					maxLength: 19,
      					pattern : '9999 9999 9999 9999'
      				},
      				'JC' : {
      					autoFormat: true,
      					cCardType: 'JCB',
      					maxLength: 19,
      					pattern : '9999 9999 9999 9999'
      				},
      				'UP' : {
      					autoFormat: true,
      					cCardType: 'UnionPay',
      					maxLength: 24,
      					pattern : '9999 9999 9999 9999 9999'
      				},
      				'default': {
      					autoFormat: false,
      					cCardType: '',
      					maxLength: '20',
      					pattern : ''
      				}
      			};

		var
			ccFormatInput = this.$el.find('#credit-card-number'),
			ccFormatCardType = _self.selectedCardType,
			inputVal = ccFormatInput.val(),
			maxLength = _self.cardTypeObj[ccFormatCardType].maxLength,
			formatPattern = _self.cardTypeObj[ccFormatCardType].pattern;

			ccFormatInput.attr( "maxlength", maxLength );
			ccFormatInput.mask(formatPattern);
			if(_self.isPasted){
				ccFormatInput.val(inputVal).trigger('input');
				ccFormatInput.unmask();
			} else {
			 ccFormatInput.val(inputVal);
			}
	},

	/*************************AutoFormatCreditCard- END*****************************************/


  savableCreditCardInfoChanged: function() {
    var saveblePreferenceMsgDiv = $('#creditCardSavebleMsgDiv'),
      _self = this,
      usePreferencePlus = $('#use-preference-plus'),
      selectedCreditCardType = $('#credit-card-type-hidden'),
      preferePlusSelection = $('#preference-selection input[name=paymentType]:checked'),
      selectedCreditCard = $('#select-credit-card input[name=selectedCreditCard]:checked');
    if ((usePreferencePlus.length && preferePlusSelection.length && preferePlusSelection.val() === 'P') ||
      (selectedCreditCard.length && selectedCreditCard.val() === 'E')) {
      saveblePreferenceMsgDiv.hide();
    } else {
      if ((saveblePreferenceMsgDiv.length && selectedCreditCardType.val() !== 'UP') && ((!selectedCreditCard.length) || (selectedCreditCard.length && selectedCreditCard.val() !== 'E'))) {
	if($('.js-credit-card-tile').data('show-all-cards') === true){
        	_self.saveCreditCardHandler();
	} else {
		saveblePreferenceMsgDiv.show();
	}
      }
    }
    _self.pubsub.publish('FROM_IFRAME_SET_HEIGHT');
  },

  saveformValues: function() {
    var _self = this;
    var selectedCreditCard = '';
    if (_self.$el.find('#credit-card-type li img.unselected').length > 0) {
      selectedCreditCard = _self.$el.find('#credit-card-type li img').not('.unselected').attr('id');
    }
    _self.config.fieldsValue = {
      'creditCard': {
        'creditCardCVVFlag': _self.$el.find('.show-cvv-section').is(':visible'),
        'selectedCreditCard': _self.$el.find('input[name="selectedCreditCard"]:checked').val(),
        'alias': _self.$el.find('#credit-card-nickname').val(),
        'nameOnCreditCard': _self.$el.find('#credit-card-name').val(),
        'creditCardTypeHidden': _self.$el.find('#credit-card-type-hidden').val(),
        'creditCardType': selectedCreditCard,
        'creditCardNumber': _self.$el.find('#credit-card-number').val(),
        'expMonth': _self.$el.find('#exp-month').val(),
        'expYear': _self.$el.find('#exp-year').val(),
        'purpose': _self.$el.find('input[name="purpose"]:checked').val()
      }
    };
  },

  prepopulateFormValues: function() {
    var formValues = this.config.fieldsValue;
    this.$el.find('#credit-card-nickname').val(formValues.creditCard.alias);
    this.$el.find('#credit-card-name').val(formValues.creditCard.nameOnCreditCard);
    this.$el.find('#credit-card-number').val(formValues.creditCard.creditCardNumber);
    this.$el.find('#credit-card-type-hidden').val(formValues.creditCard.creditCardTypeHidden);
    this.$el.find('#exp-month').val(formValues.creditCard.expMonth);
    this.$el.find('#exp-year').val(formValues.creditCard.expYear);
    this.$el.find('.show-cvv-section').toggle(formValues.creditCard.creditCardCVVFlag);
    this.$el.find('.cvv-label').toggle(formValues.creditCard.creditCardCVVFlag);
    if (formValues.creditCard.creditCardType.length > 0) {
      var $selectedCreditCard = $('#credit-card-type li img#' + formValues.creditCard.creditCardType);
      var altText = '';
      $('#credit-card-type li img').each(function() {
        altText = $(this).data('options').accept;
        $(this).removeClass('unselected').addClass('unselected').attr('title', altText + ' ').attr('alt', altText);
      });
      altText = $selectedCreditCard.data('options').selected;
      $selectedCreditCard.removeClass('unselected').attr('title', altText+' ').attr('alt', altText);
      if (this.$el.find('.cc-image-inline').length) {
        $('#credit-card-type li').addClass('unselected');
        $selectedCreditCard.parents('li').removeClass('unselected');
      }
    } else {
      $('#credit-card-type li img').each(function() {
        var altText = $(this).data('options').accept;
        $(this).removeClass('unselected').attr('title', altText + ' ').attr('alt', altText);
      });
    }
    var selectedCreditCard = 'input[name="selectedCreditCard"][value="' + formValues.creditCard.selectedCreditCard + '"]';
    this.$el.find('input[name="selectedCreditCard"]').removeAttr('checked');
    this.$el.find(selectedCreditCard).prop('checked', true);
    var purpose = 'input[name="purpose"][value="' + formValues.creditCard.purpose + '"]';
    this.$el.find('input[name="purpose"]').removeAttr('checked');
    this.$el.find(purpose).prop('checked', true);
    this.setCvvMaxLength();
  },

  showPPOverride: function(checked) {
    var _self = this;
    var $inputs = _self.$el.find('input,select');

    _self.$el.hasClass('l-guest-info-cc-section') && _self.$el.find('#credit-card-section-container').show();
    _self.$el.toggleClass('pp-override', checked);
    if (checked) {
      _self.isCreditCardDisabled = _self.$el.find('input[name="paymentMethodId"]').attr('disabled') == 'disabled' ? true : false;      _self.$el.css('min-height', '120px');
      $inputs.attr('disabled', 'disabled');
    } else if(!_self.isCreditCardDisabled) {
    		// AAB-44 and AAB-3884 - Disable Expired and Not accepted At Property card
    		var $filteredInput = $inputs.filter('[data-acceptedAtProperty!="false"]').filter('[data-expiredcreditcard!="true"]');
    		$filteredInput.removeAttr('disabled');
      _self.$el.css('min-height', '0');
    }
    this.$el.find('#selected-card-paymentMethodId').removeAttr('disabled');
    _self.creditCardInfoChanged();
  },

  compRefresh: function(data) {
    var _self = this;
    if (data && data.type === 'countryChange') {
      // Refresh the component on country change event
      _self.saveformValues();
      _self.refresh(data.context, function() {
        _self.prepopulateFormValues();
        _self.$(_self.$el).trigger('GLOBAL_ELEMENTS_REINIT.mi-select');
      });
    } else if (!_self.$el.hasClass('is-hidden')) {
      _self.pubsub.publish('FROM_IFRAME_GET_FORM_DATA');
    }
  },

  formSubmitHandler: function (formData, data) {
    var _self = this;
    var ccData = this.getCreditCardData();
    // Refresh the component on edit/close button event
    _self.contextToSend = {
      name: 'creditCardInfo',
      data: {
        'expMonth': ccData.expMonth,
        'creditCardType': ccData.creditCardTypeHidden,
        'expYear': ccData.expYear,
        'creditCardNumber': ccData.creditCardNumber,
        'nameOnCreditCard': ccData.nameOnCreditCard,
        'creditCardCVV': ccData.creditCardCVV,
        'cvvApplicable': ccData.cvvApplicable,
        'billingZipCode': $('.js-billing-zip-code').val(),
        'alias': ccData.alias,
        'saveBillingInformationLabel': $('input[type=\'checkbox\'][name=\'saveBillingInformationLabel\']:checked').val() || '',
        'preferred': 	$('#isPreferredSelected').prop("checked"),
        'vendorCode': ccData.creditCardTypeHidden,
        'purpose': ccData.purpose,
        'selectedCreditCard': ccData.selectedCreditCard,
        'paymentMethodId': _self.$el.find('input[name="paymentMethodId"]').val(),
								'encodedPaymentMethodData': _self.$el.find('#encoded-payment-method-data').val(),
        'tokenizedPanNumber' : $('#tokenized-pan-number').val(),
		'inAuthID': _self.$el.find('input[name="inAuthID"]').val(),
		'accertifyTransactionID': _self.$el.find('input[name="accertifyTransactionID"]').val(),
		'clientIpAddress': _self.$el.find('input[name="clientIpAddress"]').val(),
		'ipCountry': _self.$el.find('input[name="ipCountry"]').val(),
		'propertyCountry': _self.$el.find('input[name="propertyCountry"]').val(),
		'countryCodeSelected': _self.$el.find('input[name="countryCodeSelected"]').val(),
		'upcomingResNumList': _self.$el.find('input[name="upcomingResNumList"]').val(),
		'memberLevelCode': _self.$el.find('input[name="memberLevelCode"]').val(),
        'defaultCardHolderName': ccData.defaultCardHolderName,
        'creditCardInfoLabel': '',
        'country': ccData.country,
        'policyMessage': $('.form-message-highlight').text().trim(),
        'paymentMethodTypeCode': ccData.paymentMethodTypeCode,
        'prefCreditCard': {
          'expMonth': ccData['preferredCreditCardInformationVO.expMonth'],
          'expYear': ccData['preferredCreditCardInformationVO.expYear'],
          'creditCardNumber': ccData['preferredCreditCardInformationVO.number'],
          'nameOnCreditCard': ccData.nameOnCreditCard, //not sure
          'alias': ccData['preferredCreditCardInformationVO.alias'],
          'vendorCode': ccData['preferredCreditCardInformationVO.vendorCode'],
          'purpose': ccData['preferredCreditCardInformationVO.purpose'],
          'selectedCreditCard': ccData.selectedCreditCard,
          'paymentMethodId': ccData['preferredCreditCard.paymentMethodId'],
          'creditCardInfoLabel': $('label[for=\'preferredCreditCard\']').text().trim()
        },
        'otherCreditCard': {
          'expMonth': ccData['otherCreditCardInformationVO.expMonth'],
          'expYear': ccData['otherCreditCardInformationVO.expYear'],
          'creditCardNumber': ccData['otherCreditCardInformationVO.number'],
          'nameOnCreditCard': ccData.nameOnCreditCard, //not sure
          'alias': ccData['otherCreditCardInformationVO.alias'],
          'vendorCode': ccData['otherCreditCardInformationVO.vendorCode'],
          'purpose': ccData['otherCreditCardInformationVO.purpose'],
          'selectedCreditCard': ccData.selectedCreditCard,
          'paymentMethodId': ccData['otherCreditCard.paymentMethodId'],
          'creditCardInfoLabel': $('label[for=\'otherCreditCard\']').text().trim()
        }
      }
    };
    if (_self.$el.find('#inline-edit-black-zone-enabled').val() === 'true') {
      data = {};
      data.context = _self.getContextData();
      data.sessionToken = _self.getSessionToken();
      data.sourceURI = _self.getSourceURI();
      data.variation = _self.getVariation();
      data.context.marshaTimeout = formData.marshaTimeout;
      data.context.userState = formData.userState;
      data.context.memberLevel = ccData.memberLevel;
      data.context.startDate = ccData.startDate;

      _self.makeAjaxCall({
        url: _self.$el.find('#credit-card-inline-edit-url').val(),
        method: 'POST',
        data: JSON.stringify(data)
      }).then(function() {
        _self.inlineEditBlackZoneRefresh();
      }.bind(_self));
    } else {
      _self.inlineEditBlackZoneRefresh();
    }
  },

  inlineEditBlackZoneRefresh: function() {
    var _self = this;
    _self.refresh(_self.$el.data('component-id'), function() {
      _self.pubsub.publish('FROM_IFRAME_REMOVE_FORM_ACTION_MESSAGES');
      if (_self.$el.attr('data-error') === 'false') {
        _self.pubsub.publish('GUEST_INFO_TOGGLE_SECTION', [true]);
      }
    });
  },
  /**
   * This method toggles message for purchase points
   * @param {String} elementId of checked radio button
   * @returns {Object} instanceof current component
   */
  toggleECertificateMessage: function _toggleECertificateMessage(elementId) {
    if (elementId === 'purchase-points') {
      this.$el.find('#credit-card-charge-message').show();
    } else {
      this.$el.find('#credit-card-charge-message').hide();
    }
    return this;
  },
  /**
   * This method toggles credit card section on pubsub event from visaCheckout component
   * @param {Boolean} flag
   * @returns {Boolean} operation success or not
   */
  toggleCreditCardSection: function _toggleCreditCardSection(flag) {
    var _self = this;
    if (flag) {
      _self.pubsub.publish('FROM_IFRAME_TOGGLE_CC_DISPLAY',[flag]);
      _self.$el.find('input[name=paymentMethodId]').attr('disabled', true);
    } else {
      _self.pubsub.publish('FROM_IFRAME_TOGGLE_CC_DISPLAY',[flag]);
      _self.$(_self.$el).trigger('GLOBAL_ELEMENTS_REINIT.mi-select');
      _self.$el.find('input[name=paymentMethodId]').removeAttr('disabled');
    }
    return true;
  },
  togglePaymentOptionSection: function _togglePaymentOptionSection($section) {
    this.togglePaymentOptionHandler($section, this.config.collapseFlag);
    this.pubsub.publish('FROM_IFRAME_TOGGLE_PAYMENT_OPTION');
  },

  togglePaymentOptionSegment: function _togglePaymentOptionSegment($section, collapseFlag) {
    if (!$section.hasClass('open') && collapseFlag) {
      var _self = this;
      $section.addClass('open');
      $section.find('input[type="radio"]').prop('checked', true);
      _self.$el.find('.toggle-payment-section').slideDown('fast', function() {
        _self.pubsub.publish('FROM_IFRAME_SET_HEIGHT');
        _self.creditCardInfoChanged();
      });
    }
    return true;
  },

  /**
   * This method toggles the payment option on the credit card
   * @method togglePaymentOptionHandler
   * @return {Boolean} operation success or not
   */
  togglePaymentOptionHandler: function _togglePaymentOptionHandler($section, collapseFlag) {
    var _self = this;
    _self.config.collapseFlag = collapseFlag;
    _self.$el.find('.payment-option-toggle').removeClass('open');
    _self.$el.find('.toggle-payment-section').slideUp('fast', function() {
      _self.pubsub.publish('FROM_IFRAME_SET_HEIGHT');
      _self.creditCardInfoChanged();
    });
    _self.$el.find('.payment-option-toggle input[type="radio"]').prop('checked', false);
    _self.togglePaymentOptionSegment($section || this.$el.find('.payment-option-toggle'), this.config.collapseFlag);
    return true;
  },

   togglePaymentOptionTab: function _togglePaymentOptionTab(selectedTab) {
    var _self = this;
    //_self.config.collapseFlag = collapseFlag;
     var tabsContent = $(document).find('.m-payment-tab-content');
					if(tabsContent.hasClass(selectedTab)) {
								_self.pubsub.publish('FROM_IFRAME_SET_HEIGHT');
					} else {
       _self.pubsub.publish('FROM_IFRAME_SET_HEIGHT');
					}
  },

  /**
   * Set maxlength of cvv textbox.
   */
  setCvvMaxLength: function() {

    var $cvvTextBox = this.$el.find('.cvv-text-box');
    var $amexCardType = this.$el.find('.amex-card');
    var $nonAmexCardType = this.$el.find('.non-amex-card');
    var $currentCreditCardTypeForCvv = this.$el.find('input[name="creditCardTypeHidden"]').val();
    var $maxLengthAmex = $cvvTextBox.data('maxLengthAmex');
    var $maxLengthNonAmex = $cvvTextBox.data('maxLengthNonamex');
			 var $showBillingZipCode = $('.show-billing-zip-code-section');
			 var $cvvHelp = $('.js-cvv-help');
			 var $cvvTextBoxHybrid = this.$el.find('.cvv-text.is-hybrid');
    if ($currentCreditCardTypeForCvv === 'AX') {
      $nonAmexCardType.addClass("is-hidden");
      $amexCardType.removeClass("is-hidden");
      $cvvTextBox.prop('maxlength', $maxLengthAmex);
					 $cvvHelp.addClass($cvvTextBoxHybrid ? 'l-margin-bottom-none' : 'l-s-margin-bottom-double l-l-margin-bottom-none');
    } else {
      if (this.$el.find('#credit-card-type-hidden').val() !== '') {
        $nonAmexCardType.removeClass("is-hidden");
        $amexCardType.addClass("is-hidden");
							 $cvvHelp.addClass($cvvTextBoxHybrid ? 'l-margin-bottom-none' : 'l-s-margin-bottom-double l-l-margin-bottom-none');
      } else {
        $nonAmexCardType.addClass("is-hidden");
        $amexCardType.addClass("is-hidden");
							 $cvvHelp.removeClass($cvvTextBoxHybrid ? 'l-margin-bottom-none' : 'l-s-margin-bottom-double l-l-margin-bottom-none');
      }
      $cvvTextBox.prop('maxlength', $maxLengthNonAmex);
    }
  },
  /**
   * This method will set the flag on changing info of credit.
   * @param {target} $target
   */
  setCardInfoChangedFlag: function($target) {
    $target.closest('#credit-card-section-container')
      .find('input[name="selectedCreditCard"]:checked')
      .data('isCardInfoChanged', true);
  },
  /**
   * This method will check changing info of credit
   * @param {boolean} cardInfoAttr - Boolean flag for card info changed
   * @returns {Boolean} operation success or not
   */
  isCardInfoChanged: function(cardInfoAttr) {
    this.$el.find('.cvv-text-box').val('');
    return cardInfoAttr === true;
  },
  /**
   * To toggle the visibility of CVV
   * @param {boolean} show.
   */
  toggleCVV: function() {
    var _self = this;
    if (_self.$el.find('#selected-card-paymentMethodId').val() === '' || _self.$el.find('#credit-card-number').val() === '') {
      if($('.show-billing-zip-code-section').length) {
					 	_self.handleBillingZipCode();
						}
      _self.$el.find('.show-cvv-section').show();
      _self.$el.find('.cvv-label').show();
      var creditCardNumberSelected = $('#credit-card-number');
      if(creditCardNumberSelected.is('[readonly]')) {
	 creditCardNumberSelected.val('');
	 creditCardNumberSelected.attr('readonly', false);
	 $('#input-string').val('');
	 $('#saveCreditCardField').prop("checked", false);
      }
      if($('#creditCardSavebleMsgDiv').is(":visible")){
      	_self.saveCreditCardHandler();
      }
      _self.$el.find('#exp-date').not('.t-form-error-frame').val('');
    } else {
      $('.show-billing-zip-code-section').addClass('is-hidden');
      _self.$el.find('.show-cvv-section').hide();
      _self.$el.find('.cvv-label').hide();
      if ($('.js-credit-card-tile').data('show-all-cards') &&
		$('.guest-credit-card-list input:checked').data("expiredcreditcard")) {
	  _self.$el.find('#encoded-payment-method-data').val('');
							$('#credit-card-cvv-applicable').val(false);
      }
    }
    _self.$el.find('.cvv-text-box').val('');
    $('.js-billing-zip-code').val('');
  },
  /**
   * Check for numbers only input in cvv field on keypress
   * @param {event} event - The keypress event.
   */
  cvvKeypressHandler: function(event) {
    var isPasteEvent = this.isPasteEventKey(event);

    if (isPasteEvent) {
      if (/^\d+$/.test(this.getEventClipboardData(event))) {
        event.preventDefault();
      }
    } else {

      -1 !== $.inArray(event.keyCode, [46, 8, 9, 27, 13, 110]) ||
        /65|67|86|88/.test(event.keyCode) &&
        (!0 === event.ctrlKey || !0 === event.metaKey) ||
        35 <= event.keyCode && 40 >= event.keyCode ||
        (event.shiftKey || 48 > event.keyCode || 57 < event.keyCode) &&
        (96 > event.keyCode || 105 < event.keyCode) && event.preventDefault();
    }
    this.pubsub.publish('FROM_IFRAME_SET_HEIGHT');
  },
  /**
   * Get the clipboard data.
   * @param {event} event
   * @returns {string} string - Returns the event's clipboard Data.
   */
  getEventClipboardData: function(event) {
    return event.originalEvent.clipboardData || window.clipboardData;
  },
  /**
   * Restrict alphabet and special char input in cvv field on paste.
   * @param {event} event - paste event
   */
  cvvPasteHandler: function(event) {
    var clipboardData = event.originalEvent.clipboardData || window.clipboardData,
      cvv = clipboardData.getData('text'),
      regex = /^\d+$/;

    if (!regex.test(cvv)) {
      event.preventDefault();
    }
    this.pubsub.publish('FROM_IFRAME_SET_HEIGHT');
  },

  /**
   * Validate if key pressed is paste event.
   * @param {event} event
   * @returns {string} string - Returns the event's clipboard Data.
   */
  isPasteEventKey: function(event) {
    var keyCode = (event.which) ? event.which : event.keyCode;
    var keyCodeChar = String.fromCharCode(keyCode).toLowerCase();

    return event.ctrlKey && keyCodeChar === 'v';
  },
  /**
   * This method show/hide on checked/unchecked of purchase point
   * @param {Boolean} checked flag for purchase point
   * @returns {Boolean} operation success or not
   */
  ccByPassToggleSection: function _ccByPassToggleSection(flag) {
    if (this.$el.data('bypassccapplicable')) {
      if (this.$el.hasClass("review-changes")) {
        this.$el.find('#selected-card-paymentMethodId').val('');
      }
      if(flag){
        this.$el.removeClass('is-hidden');
        this.$el.find('.js-edit-text').trigger('click');
      }else{
        this.$el.find('.js-credit-card-form').addClass('is-hidden');
        this.$el.find('.js-saved-card-toggle').removeClass('is-hidden');
        this.$el.addClass('is-hidden')
      }
      this.$el.find('#credit-card-bypass-applicable').attr('value', !flag);
      this.config.ccSectionVisible = flag;
    }
    return true;
  },

  /**
   * This method publishes an event to post the card details
   * @method postFrameFormFields
   * @return {Boolean} operation success or not
   */
  postFrameFormFields: function _postFrameFormFields() {
    var formData = this.getCreditCardData();
    if($('#credit-card-section').data('isuserauthenticated')) {
    	var text = "";
    	if($('.guest-credit-card-add input:checked').length) {
							text = "AC";
						}
							if($('.guest-credit-card-list input:checked').length) {
								text = "SC";
							}
   		 text = (text + (formData.creditCardNumber != '' ? 'N' : 'X')
								+ (formData.expMonth != '' ? 'M' : 'X')  + (formData.expYear != '' ? 'Y' : 'X')
								+ (formData.creditCardCVV != '' ? 'V' : 'X')  + (formData.purpose != '' ? formData.purpose : 'X'));
      console.error("VOC Entered " + text);
				}
    var saveBillingInformationcheck = $('input[type=\'checkbox\'][name=\'saveBillingInformationLabel\']');
    var travelAgentCheck = $('#travel-agent-checkbox', parent.document);
    if(!saveBillingInformationcheck.prop('checked')) {
      saveBillingInformationcheck.val('');
      formData.saveBillingInformationLabel = '';
    }
    if(travelAgentCheck.prop('checked')) {
      formData.preferencePlusNumber = $('#preference-plus-number', parent.document).val();
    }
    this.pubsub.publish('FROM_IFRAME_SET_CC_DATA', [formData]);
    return true;
  },

  getCreditCardData: function _getCreditCardData() {
    var formData = {};
    this.$el.find('input, select, button').each(function(index, element){
      if(element.name){
        formData[element.name] = $(this).prop('value');
      }
    });
    var formattedCreditCardNumber = this.$el.find("#credit-card-number").val();
    formData.creditCardNumber = formattedCreditCardNumber.replace(/\s/g, '');
    formData.selectedCreditCard = this.$el.find("input[name='selectedCreditCard']:checked").val();
    formData.purpose = this.$el.find("input[name='purpose']:checked").val();
    if(this.$el.find("input[name='selectedCreditCard']:checked").data("freedom-token")){
      formData.freedomPayToken = this.$el.find("input[name='selectedCreditCard']:checked").data("freedom-token");
    }
    return formData;
  },

  toggleCCChargeMessage: function _toggleCCChargeMessage() {
    this.defObj.creditCardChargeMsg.toggle();
  },

  getCCCardMessageHandler: function _getCCCardMessageHandler() {
    this.defObj.creditCardChargeMsg.show();
  },

  /**
   * This function is called as soon as bookNow.js gets loaded
   * @return null
   */
  setCCLoaded: function _setCCLoaded() {
  		if($('#credit-card-section').data('isuserauthenticated')) {
						console.error("VOC Loaded");
				}
    this.pubsub.publish('FROM_IFRAME_CC_LOADED');
  },
		/**
     * This method registers the creditCard Popup from iframe
     * @method registerCCPopUp
     * @returns {boolean} true when the function executes successfully
     */
    registerCCPopUp: function _registerCCPopUp(popUpConfig) {
      new Popup(popUpConfig).register();
      return true;
    },

    getCcPopUp: function _getCcPopUp(){
      	var _self = this,
      	whyWeAskPopUpTriggerer = _self.$el.find('a.js-credit-card-popover');
      	event.preventDefault();
		_self.pubsub.publish('WHY_WE_ASK_POPUP_TRIGGERER', [whyWeAskPopUpTriggerer.attr('href')]);

	},						

    /**
     * This method removes the billing-zip-code value based on countrycode selected in address-info
     * @method handleBillingZipCode
     **/
    handleBillingZipCode: function _handleBillingZipCode(){
      var billingCodeContainer = $('.show-billing-zip-code-section');
      var countryList =  $('.js-billing-zip-code-container').data('eligible-country-list');
      var countryCode = $('.js-billing-zip-code-container').data('country-selected');
      $('.js-billing-zip-code').val('');
      //Hide or show billingzipcode based on country selected is available in the countryList
      if(countryList){
      	for(var i=0; i< countryList.length; i++){
        if(countryList[i] === countryCode){
             billingCodeContainer.removeClass('is-hidden');
             break;
        } 
        else {
            billingCodeContainer.addClass('is-hidden');
        }
      	}
      }
    },

   /**
   * Check the payment type selected and publish modification type for click tracking.
   */
  creditCardInfoChanged: function _creditCardInfoChanged() {
    var modificationType;
    var $travelAgentCheckBox = $('#use-preference-plus', parent.document);
    var $paymentOptionRadioButton = $('#alterntiave-payment-option', parent.document);

    if ($travelAgentCheckBox.prop('checked')) {
      modificationType = "Preference Plus";
    }
    else if ($paymentOptionRadioButton.prop('checked') || !$('.pci-data-frame', parent.document).is(':visible')) {
      modificationType = "Click to pay";
    }
    else if ($('#credit-card-section').data('isuserauthenticated')) {
      if ($('#is-alternate-card').val() === 'true' || $('input[type=radio][name=selectedCreditCard]:checked').val() === 'A') {
        modificationType = "New Card";
      }
      else {
        modificationType = "Saved Card";
      }
      if ($('#submit-guest-credit-card').length) {
        $('#submit-guest-credit-card').addClass('custom_click_track').attr('custom_click_track_value', 'Credit Card Information|Apply|internal|evar199=' + modificationType);
      }
    }
    else {
      modificationType = "New Card";
    }

    this.pubsub.publish('FROM_IFRAME_CC_MOD_TYPE', [modificationType]);

  }

}));
